import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgFieldApply = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 12" {...props}>
    <path fill="none" stroke="#007AFF" d="M0 6.449 4.63 11 15 1" />
  </svg>
);
const Memo = memo(SvgFieldApply);
export default Memo;
